import type { FC } from "react"
import { useDevice } from "@shared/hooks"
import { useLactateAutoImport } from "./useLactateAutoImport"

/**
 * Headless app-level runner that auto-attaches EN605 lactate measurements to
 * matching workouts in the background. Renders nothing; mount once inside the
 * authenticated app shell (needs Apollo + MeContext). Active only in the native
 * app — on the web there's no lactometer bridge.
 */
export const LactateAutoImport: FC = () => {
  const { isNativeApp } = useDevice()
  useLactateAutoImport(isNativeApp)
  return null
}
